var map = {
	"./dice-logo1.svg": "e405",
	"./dice-logo2.svg": "4e84",
	"./dice-logo3.svg": "8fcb",
	"./dice1.svg": "1ffb",
	"./dice2.svg": "afb3",
	"./dice3.svg": "4aa0",
	"./dice4.svg": "e6e6",
	"./dice5.svg": "804c",
	"./dice6.svg": "124f",
	"./undraw_campfire_s6y4.svg": "884e",
	"./undraw_camping_noc8.svg": "4de43",
	"./undraw_into_the_night_vumi.svg": "1f90",
	"./undraw_moonlight_5ksn.svg": "6634",
	"./undraw_pie_chart_6efe.svg": "0117",
	"./undraw_reading_0re1.svg": "562f",
	"./undraw_visual_data_b1wx.svg": "9da3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";